import { CheckIcon, LinkIcon, UploadIcon, XIcon } from "@primer/octicons-react";
import { Box, Button, Link, TextInput } from "@primer/react";
import { useEffect, useMemo, useRef, useState } from "react";
import { uploadApi } from "../../../../api/uploadApi";
import { chieuCaoCanNangApi } from "../../../../api/chieuCaoCanNangApi";
import { useCommonContext } from "../../../../contexts/common";
import { NotifyHelper } from "../../../../helpers/toast";
import { useCommonSelectedHook } from "../../../../hooks/useCommonSelectedHook";
import styles from "./ChieuCaoCanNangImport.module.css";

interface IChieuCaoCanNangImportModalProps {
    onClose: () => void;
    dm_truong_id: number;
}

const ChieuCaoCanNangImport = (props: IChieuCaoCanNangImportModalProps) => {
    const { translate } = useCommonContext();
    const { onClose, dm_truong_id } = props;
    const [uploadedFileName, setUploadedFileName] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const componentDidMount = useRef<boolean>(false);
    const [dataSouceValidated, setDataSouceValidated] = useState<any[]>([]);
    const { nam_hoc } = useCommonSelectedHook();

    const notValidCount = useMemo<number>(() => {
        return dataSouceValidated.filter((x) => x["Thông tin lỗi"] !== "" && x["Thông tin lỗi"] != null).length;
    }, [dataSouceValidated]);
    const handleSelectFile = () => {
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        input.setAttribute("accept", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel");
        input.click();
        input.onchange = async () => {
            var file = input && input.files ? input.files[0] : null;
            if (file) {
                const res = await uploadApi.uploadExcel(file);
                if (res.is_success) {
                    setUploadedFileName(res.data.url);
                } else {
                    NotifyHelper.Error(res.message ?? "Error");
                }
            }
        };
        input.remove();
    };
    useEffect(() => {
        componentDidMount.current = true;
        if (uploadedFileName !== "") {
            setIsLoading(true);
            handleReadUploadedFile();
            setIsLoading(false);
        }
    }, [uploadedFileName]);

    const handleReadUploadedFile = async () => {
        setIsLoading(true);
        if (!componentDidMount.current) return;
        setIsLoading(false);
        await handleValidateImportFile();
    };
    const handleValidateImportFile = async () => {
        setIsLoading(true);
        const datasend = { fileName: uploadedFileName, sheetIndex: 0 };
        const res = await chieuCaoCanNangApi.ValidateImport(datasend, dm_truong_id);
        if (!componentDidMount.current) return;
        if (res.is_success) {
            setDataSouceValidated(res.data);
        }
        setIsLoading(false);
    };

    const hanldeImport = async () => {
        setIsLoading(true);
        const datasend = { fileName: uploadedFileName, sheetIndex: 0 };
        try {
            if (dm_truong_id > 0) {
                const res = await chieuCaoCanNangApi.Import(datasend, dm_truong_id, nam_hoc);
                if (!componentDidMount.current) return;
                if (res.is_success) {
                    NotifyHelper.Success(`Import thành công!`);
                } else {
                    NotifyHelper.Error(`Lỗi import: ${res.message ?? "Error"}`);
                }
                onClose();
            }
        } catch (error) {
            NotifyHelper.Error("Có lỗi xảy ra trong quá trình import");
        } finally {
            setIsLoading(false);
        }
    };

    const columns = useMemo(() => {
        if (!dataSouceValidated || dataSouceValidated.length === 0) return [];
        const keys = Object.keys(dataSouceValidated[0]).filter((key) => key !== "0" && key !== "ID" && key !== "id");
        return keys.map((key) => ({ dataField: key, caption: key }));
    }, [dataSouceValidated]);

    return (
        <>
            <Box sx={{ overflow: "hidden", display: "flex", flexDirection: "column", maxHeight: "85vh" }}>
                <Box sx={{ display: "flex" }}>
                    <div className={styles.actions}>
                        <div className={styles.action_item}>
                            <Button leadingVisual={UploadIcon} onClick={handleSelectFile} size="medium">Upload file</Button>
                        </div>
                        {uploadedFileName && (
                            <TextInput sx={{ ml: 2, width: 400 }} value={uploadedFileName} readOnly />
                        )}
                        <div className={styles.action_item}>
                            <Link href={`/api/template/chieucao-cannang`} target="_blank">
                                <Button sx={{ color: "blue" }} variant="invisible" leadingVisual={LinkIcon}>{translate(`Tải mẫu import tại đây`)}</Button>
                            </Link>
                        </div>
                    </div>
                </Box>
                <Box sx={{ flex: 1, overflow: "auto" }}>
                    {dataSouceValidated.length > 0 && (
                        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 10 }}>
                            <thead>
                                <tr>
                                    {columns.map((col, i) => (
                                        <th key={i} style={{ border: "1px solid #ddd", padding: "6px", textAlign: "left", backgroundColor: "#f5f5f5" }}>{col.caption}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {dataSouceValidated.map((row, i) => (
                                    <tr key={i}>
                                        {columns.map((col, j) => (
                                            <td key={j} style={{ border: "1px solid #ddd", padding: "4px" }}>{row[col.dataField]}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 2 }}>
                    <Button leadingVisual={XIcon} onClick={onClose}>Đóng</Button>
                    <Button leadingVisual={CheckIcon} variant="primary" disabled={notValidCount > 0 || isLoading} onClick={hanldeImport}>Import</Button>
                </Box>
            </Box>
        </>
    );
};

export default ChieuCaoCanNangImport;
